import CityPageTemplate from "../city-template/CityPageTemplate";
import { pocatelloConfig } from "./data";

export default function PocatelloPage() {
  return <CityPageTemplate config={pocatelloConfig} />;
}